import { gql } from '@apollo/client';

export default gql`
  mutation rebook(
    $bookingReference: String!
    $currency: Currency!
    $segments: [ExchangeInputSegment]!
    $replaceItems: [String!]
    $overrideAftersalesFees: Boolean!
    $overrideBookingLimits: Boolean!
    $overrideAftersalesRules: Boolean!
    $rebookReason: String
    $isFlowForward: Boolean
    $isExchangingOFETrain: Boolean
  ) {
    rebook(
      bookingReference: $bookingReference
      currency: $currency
      segments: $segments
      replaceItems: $replaceItems
      overrideAftersalesFees: $overrideAftersalesFees
      overrideBookingLimits: $overrideBookingLimits
      overrideAftersalesRules: $overrideAftersalesRules
      rebookReason: $rebookReason
      isFlowForward: $isFlowForward
      isExchangingOFETrain: $isExchangingOFETrain
    ) {
      reference
      totalPendingCancellationFarePrice: totalPendingCancellationFarePriceWithCurrency(currency: $currency)
      totalPendingCreationFarePrice
      totalExchangeFee: totalExchangeFeeWithCurrency(currency: $currency)
      fees {
        code
        name
        price
        cancelled
        provisional
      }
      pendingCancellationLegs {
        ...pendingLeg
      }
      pendingCreationLegs {
        ...pendingLeg
      }
      isPackage
      hotels {
        itemRef
      }
      productFamilies {
        code
        name
        familyGroup
      }
      outboundExtras {
        ...product
      }
      inboundExtras {
        ...product
      }
    }
  }

  fragment pendingLeg on Leg {
    direction
    serviceType {
      name
      code
    }
    serviceName
    fees {
      name
      code
      price
      cancelled
      provisional
    }
    bookingItems: products {
      ...product
    }
    products {
      ...product
    }
  }

  fragment product on Product {
    price
    cancelled
    provisional
    itemRef
    code
    originalPrice
    itemId
    passengerId
    productFamily {
      code
      name
      familyGroup
    }
  }
`;
